import axios from 'axios';

// Resolve API base smartly:
//  - If REACT_APP_BACKEND_URL is set → use it (production custom-domain proxy uses this).
//  - Otherwise fall back to same-origin "/api" (preview ingress + local dev).
// The Bearer-token fallback (below) makes us resilient to 3rd-party cookie blocking on Safari.
function resolveApiBase() {
  const env = (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/+$/, '');
  if (env) return `${env}/api`;
  return '/api';
}
const API_BASE = resolveApiBase();

// WebSocket base — mirror the API base host. Critical for production to point at the same
// backend that handles HTTP (Cloudflare in front of gharsetgo.work serves both via /api).
export const WS_BASE = (() => {
  if (typeof window === 'undefined') return '';
  const env = (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/+$/, '');
  if (env) return env.replace(/^http/, 'ws') + '/api';
  return window.location.origin.replace(/^http/, 'ws') + '/api';
})();

const TOKEN_KEY = 'gsg_jwt';

export function getStoredToken() {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
}
export function setStoredToken(token) {
  try { token ? localStorage.setItem(TOKEN_KEY, token) : localStorage.removeItem(TOKEN_KEY); } catch {}
}

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach Bearer token as a fallback when cookies are blocked (Safari ITP, Brave shields, etc.)
api.interceptors.request.use((config) => {
  const t = getStoredToken();
  if (t) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export default api;
